import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmdOverlayModule } from '../../overlay/overlay.module';
import { AmdDropdownComponent } from './dropdown.component';
export class AmdDropdownModule {
}
AmdDropdownModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, AmdOverlayModule],
                declarations: [AmdDropdownComponent],
                exports: [AmdDropdownComponent]
            },] },
];
/**
 * @nocollapse
 */
AmdDropdownModule.ctorParameters = () => [];
function AmdDropdownModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdDropdownModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdDropdownModule.ctorParameters;
}
//# sourceMappingURL=dropdown.module.js.map
//# sourceMappingURL=dropdown.module.js.map
